import { ParkingBaySection } from './parking-bay-section';
import { User } from './user';

export class ParkingBay {
  parking_bay_number!: string;
  parking_bay_section_uuid!: string;
  description?: string;
  occupation_status!: string;
  status!: string;
  user_uuid!: string;
  date_deleted?: number;
  uuid!: string;
  date_created!: number;
  date_updated!: number;

  user?: User;
  parking_bay_section?: ParkingBaySection;

  static getSortColumns() {
    return [
      'parking_bay_number',
      'occupation_status',
      'status',
    ];
  }


  constructor(data: any) {
    this.user_uuid = data.user_uuid;
    this.parking_bay_number = data.parking_bay_number;
    this.description = data.description;
    this.parking_bay_section_uuid = data.parking_bay_section_uuid;
    this.occupation_status = data.occupation_status;
    this.status = data.status;
    this.date_deleted = data.date_deleted;
    this.uuid = data.uuid;
    this.date_created = data.date_created;
    this.date_updated = data.date_updated;

    if (data.user) {
      this.user = new User(data.user);
    }
    if (data.parking_bay_section) {
      this.parking_bay_section = new ParkingBaySection(data.parking_bay_section);
    }
  }
}
